import React from "react";

function Footer() {
  return (
    <div>
      <div className="footer">
        <div className="foot">
          <div className="daya">
            <div className="handle glow" id="verti">
              <li>
                <a href="https://github.com/AdityaGaur7">
                  <i className="fa-brands fa-github"></i>
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/__aditya_gaur_090/">
                  <i className="fa-brands fa-instagram"></i>
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/in/aditya-gaur-mmmut/">
                  <i className="fa-brands fa-linkedin"></i>
                </a>
              </li>
              <li>
                <a href="https://www.youtube.com/channel/UCuThDiAO3aXPStVmssLssKQ">
                  <i className="fa-brands fa-youtube"></i>
                </a>
              </li>
              <li>
                <a href="https://twitter.com/Aditya7112027">
                  <i className="fa-brands fa-twitter"></i>
                </a>
              </li>
            </div>
          </div>
        </div>
        <div className="base">
          <h3>© 2025 Aditya-All Rights Reserved.</h3>
        </div>
      </div>
    </div>
  );
}

export default Footer;
